import { FC } from 'react';
import { OmniSearch } from 'elements/OmniSearch';
import { Cart } from 'components/Shared/Cart';
import { useIsLoggedIn } from 'hooks/user/useIsLoggedIn';
import { Login, Register } from './authorization';
import { AuthButtons } from './components/AuthButtons';
import { UserPanel } from './components/UserPanel';
import { Profile } from './profile';
import {
  AccountLayout,
  AccountProps,
  AccountProvider,
  AccountView,
  defaultProps
} from './providers/AccountProvider';
import * as Styled from './styles';
import { IS_DEFAULT_MODE, IS_FTNFT_AM_MODE } from '../../constants/app/configs';

export const Account: FC<AccountProps> = ({ configs } = defaultProps) => {
  const { isLoggedIn } = useIsLoggedIn();
  const _layout = configs?.accountLayout || AccountLayout.POPUP;
  const _view = configs?.accountView || AccountView.DEFAULT;
  const _showCart = configs?.showCart || false;
  const _joinWithOneButton = configs?.joinWithOneButton || false;
  const isOnPage = _layout === AccountLayout.ONPAGE;
  const isRegisterView = _view === AccountView.REGISTER;
  const isLoginView = _view === AccountView.LOGIN;

  return (
    <AccountProvider
      value={{
        configs: {
          showCart: _showCart,
          accountView: _view,
          accountLayout: _layout,
          joinWithOneButton: _joinWithOneButton
        }
      }}
    >
      {isOnPage && isRegisterView && <Register />}
      {isOnPage && isLoginView && <Login />}
      {!isOnPage && (
        <Styled.AccountWrapper>
          {!isLoggedIn && <AuthButtons />}
          {isLoggedIn && <UserPanel />}
          {configs?.showCart && <Cart />}
          {IS_FTNFT_AM_MODE || IS_DEFAULT_MODE ? <OmniSearch /> : null}
          <Profile />
        </Styled.AccountWrapper>
      )}
    </AccountProvider>
  );
};
